import { defineMessage } from 'services/localization';

export const messages = {
    step1: defineMessage('start_with_clicking_on__lues_you_want_to_select'),
    step2: defineMessage('click_on_the_button_to___to_the_group_of_values'),
    step3: defineMessage('now_you_have_all_your_v_lues_you_want_to_select'),
    step4: defineMessage('click_on_the_button_to__rom_the_selected_values'),
};
